import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PaymentApiService} from '../api/payment-api.service';

@Component({
    selector: 'app-payment-cancel',
    template: `
    <div class="container mt-5">
      <h2>Payment Cancelled</h2>
      <p>Your payment was cancelled. Please try again.</p>

      <button class="btn btn-primary" (click)="goBack()">Go Back</button>
    </div>
  `
})
export class PaymentCancelComponent implements OnInit {

    pageid?: number;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private paymentApi: PaymentApiService
    ) {
    }

    ngOnInit() {
        this.pageid = Number(this.route.snapshot.queryParamMap.get('pageid'));
        // Best effort: lets the server record that the payer backed out instead of leaving the payment "unknown".
        const sessionId = this.route.snapshot.queryParamMap.get('session_id');
        if (sessionId) {
            this.paymentApi.cancelSession(sessionId).subscribe({error: () => {}});
        }
    }

    goBack() {
        if (this.pageid === 2) {
            this.router.navigate(['/biz-conf']);
        } else if (this.pageid === 4) {
            const eventReturnPath = sessionStorage.getItem('eventReturnPath');
            const eventId = sessionStorage.getItem('eventId');
            if (eventReturnPath) {
                this.router.navigateByUrl(eventReturnPath);
                return;
            }
            if (eventId) {
                this.router.navigate(['/event-home', eventId]);
                return;
            }
            this.router.navigate(['/profile']);
        } else {
            this.router.navigate(['/register']);
        }
    }
}
